import { AxiosInstance } from 'axios';
import { MifidReportPayload } from '@/pages/ComplianceCentre/types'

export default class ComplianceCentreAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }
//  -------------------------------
//  Fund Module APIS  / V2 Fund Level admin Page
//  -------------------------------

async getClassificationTagsBankRelationships() {
  return this.client.get(
    'v2/fund-level-hedging/get-classification-tags-bank-relationships/',
  );
}
async getBankFundCompanyPlatformMapping() {
      return this.client.get(
        'v2/fund-level-hedging/get-bank-fund-company-platform-mapping/',
      );
}
async getAllTransactionPlatforms(payload?: any) {
  return this.client.get(
    'v2/fund-level-hedging/get-all-transaction-platforms/',
    { params: payload }
  );
}

async createFundCompany(payload: any) {
    return this.client.post(
      'v2/fund-level-hedging/create-fund-company/',
      payload,
    );
  }

async createClassificationTagBankRelationship(payload: any) {
    return this.client.post(
      'v2/fund-level-hedging/create-classification-tag-bank-relationship/',
      payload,
    );
  }

async createBankFundCompanyPlatformMapping(payload: any) {
    return this.client.post(
      'v2/fund-level-hedging/create-bank-fund-company-platform-mapping/',
      payload,
    );
  }

  async updateClassificationTagBankRelationship(payload: any) {
    return this.client.post(
      'v2/fund-level-hedging/update-classification-tag-bank-relationship/',
      payload,
    );
  }

  async updateBankFundCompanyPlatformMapping(payload: any) {
    return this.client.post(
        'v2/fund-level-hedging/update-bank-fund-company-platform-mapping/',
        payload,
      );
    }
  async updateFundCompany(payload: any) {
    return this.client.post(
      'v2/fund-level-hedging/update-fund-company/',
      payload,
    );
  }


//  -------------------------------
//  Fund Module Aactions  / V2 Fund Level admin Page
//  ------------------------------- Good Stuffff

    async getSteelEyeLogs() {
    return this.client.get('v2/fund-level-hedging/get-steel-eye-logs/');
    }

    async getSteelEyeLogS3Url(steelEyeLogId: number) {
      return this.client.get(
        `v2/fund-level-hedging/get-steel-eye-log-s3-url/${steelEyeLogId}/`,
      );
    }

    async downloadMifidReportV2(payload: MifidReportPayload) {
      const url = '/v2/fund-level-hedging/download-mifid-report-v2/';
      return await this.client.post(url, { data: payload });
    }

}
